import React from 'react';

/**
 * ADMIN-Badge (Marcel 2026-10-21): Plattform-Admins werden ÜBER DEN RANG gekennzeichnet
 * (Backend liefert isAdmin / authorIsAdmin / senderIsAdmin aus user.role), nicht über „(Admin)“
 * im Anzeigenamen. Ein Baustein für alle Stellen: Profil, Suche, Kommentare, Beiträge, Chats, Forum.
 * Rendert nichts, wenn das Kennzeichen fehlt (altes Backend) oder false ist.
 */
export const isAdminFlag = (value: unknown): boolean => value === true;

const AdminBadge: React.FC<{ isAdmin?: boolean | null; size?: 'xs' | 'sm'; className?: string }> = ({ isAdmin, size = 'xs', className = '' }) => {
  if (!isAdminFlag(isAdmin)) return null;
  const sizing = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-1.5 py-px text-[9px]';
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-md border border-[#3fced1]/40 bg-[#3fced1]/15 font-extrabold uppercase tracking-wider text-[#3fced1] leading-none ${sizing} ${className}`}
      data-testid="admin-badge"
      title="DartCloud-Admin"
    >
      Admin
    </span>
  );
};

export default AdminBadge;
